import { Component, NgZone, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationPage } from '../../models/application-form.model';
import { DocObj } from '../../models/doc-upload.model';
import { DocUploadService } from '../../services/doc-upload.service';
import { LeadFormService } from '../../services/lead-form.service';
import { constants } from '../../utitlity/constant';
import { Helper } from '../../utitlity/helper';
import { CameraComponent } from '../camera/camera.component';

@Component({
  selector: 'app-poa-doc',
  template: require('./poa-doc.component.html'),
  styles: [require('./poa-doc.component.css')]
})
export class PoaDocComponent implements OnInit {
  appRefNumber: any;
  applicationAEMResponse: any;
  questions: any;
  aelList: any;
  isLoaded: boolean;
  isFeedbackForm: boolean;
  showThankyou: boolean;
  thankyouMessage: string;
  thankyoupage: any;
  isTncDeclarationChecked: boolean = false;
  leadFormDetails: any;
  leadManagementDetails: any;
  fileToUpload: File = null;
  @ViewChild('warningPopup') warningPopup;
  checked: boolean = false;
  checkedDisclaimer: boolean = false;
  proofOfAddressValid: boolean = false;
  @ViewChild('leadForm') accountForm: any;
  disableFormField: boolean = false;
  @ViewChildren(CameraComponent) camera: QueryList<CameraComponent>;
  currentCamera: CameraComponent;
  cameraList: CameraComponent[];
  currentTabIndex: any;
  proofOfAddressDocData;
  arnNo: string = '';
  validArn: boolean = false;
  uploadSuccesful: boolean = false;
  toggleBool: boolean = false; 
  isEEIDFalg: boolean;
  proofOfAddressOptions: any;
  showPOA: boolean = false;

  constructor(private leadFormService: LeadFormService,
    private router: Router,
    private zone: NgZone,
    private docUploadService: DocUploadService) { }

  ngOnInit(): void {
    this.initialiseObjects();
    if (sessionStorage.getItem('arnNo')) {
      this.arnNo = sessionStorage.getItem('arnNo');
      this.getJson();
     
    }
    else {
      this.router.navigate(['/POA']);
    }
   
    // remove this
    // this.getJson();
  }


  getJson() {

    this.proofOfAddressDocData = {
      "docInfo":
      {
        "docName": "ProofOfAddress",
        "docCode": "POA",
        "docLimit": "1",
        "index": "POA_1",
        "fileContent": "File Content",
        "fileNetId": null,
        "fileName": null,
        "files": []

      }

    }
  }
  initialiseObjects() {
    this.isLoaded = false;
    this.showThankyou = false;
    this.isFeedbackForm = false;

    this.leadFormService.getPOAFormData()
      .then((response) => {
        this.applicationAEMResponse = JSON.parse(JSON.stringify(response));
        let modifiedAppData = new ApplicationPage(this.applicationAEMResponse);
        this.questions = modifiedAppData.applicationForm.sections;
        Helper.enableSpinner(false);
        this.isLoaded = true;

      }, (err) => {
        Helper.enableSpinner(false);
        // this.redirectPageTo("/error");
      });

  }


  redirectPageTo(page) {
    Helper.enableSpinner(false);
    this.zone.run(() => {
      this.router.navigate([page]);
    });
  }

  onFieldChange(event) {
  }
  onTypeaheadFieldChange(event) {
  }
  getRows(panel) {
    return Object.keys(panel.panelRows);
  }
  getKeys(pnl) {
    return Object.keys(pnl);
  }
  checkValid() {
    let isValid: boolean = false;
    if (this.proofOfAddressValid) {
      isValid = true;
    }

    return isValid;

  }
  changeEvent(event) {

    if (event) {
        this.toggleBool = true;
    }
    else {
        this.toggleBool = false;
    }
}
  documentAction(documentObj) {
    let fileObj: DocObj = documentObj.docObj;
    let param;
    Helper.enableSpinner(true);
    this.actionType(documentObj);
  }

  actionType(documentObj) {
    switch (documentObj.type) {
      case 'upload':
        this.uploadDocument(documentObj);

        break;
      case 'delete':
        this.deleteDocument(documentObj);
    }
  }
  uploadDocument(documentObj) {
    let fileObj;
    //Helper.enableSpinner(true);
    if (documentObj.docObj) {
      fileObj = documentObj.docObj;
    }
    else if (documentObj.documentSelected && documentObj.documentSelected.files.length > 0) {
      fileObj = documentObj.documentSelected.files[0].file;
    }
    let fileName: string = documentObj.docObj ? documentObj.docObj.name : documentObj.documentSelected && documentObj.documentSelected.files[0].fileName;
    let param = {
      file: fileObj,
      mapAsJson: {
        docCode: documentObj.documentSelected.docCode,
        docName: fileName,
        arnNo: this.arnNo,//'21687535438485116',//this.applicationData.appRefNumber,
        docIndex: documentObj.documentSelected.index
      }
    }
    let formData = new FormData();
    formData.append('file', param.file);
    formData.append('mapAsJson', JSON.stringify(param.mapAsJson));
    this.uploadSuccesful = false;
    this.docUploadService.uploadDocument(formData)
      .then(() => {
        documentObj.documentSelected.docUploadMsg = this.docUploadService.getDocUploadApiMessage('Document Upload is successful.', 'success');
        this.docUploadService.clearDocUploadMsg(documentObj.documentSelected);
        this.isDocUploadValid(documentObj.documentSelected.docName, true);
        this.uploadSuccesful = true;
        Helper.enableSpinner(false);

      }, (err) => {
        documentObj.documentSelected.docUploadMsg = this.docUploadService.getDocUploadApiMessage('Document Upload failed.', 'danger');
        this.docUploadService.clearDocUploadMsg(documentObj.documentSelected);
        this.isDocUploadValid(documentObj.documentSelected.docName, false);
        Helper.enableSpinner(false);

      })
  }

  deleteDocument(documentObj) {

    documentObj.documentSelected.files.length = 0;
    this.isDocUploadValid(documentObj.documentSelected.docName, false);
    Helper.enableSpinner(false);


  }
  submitForm() {
    let leadFormDetails = JSON.parse(sessionStorage.getItem('formDetails'));
    let finalLeadFormDetails = { ...leadFormDetails };

    Helper.enableSpinner(true);
        // this.leadFormService.retrieveToken(this.appRefNo).then((token) => {
        this.leadFormService.poaFormSubmission(finalLeadFormDetails)
            .then((response) => {
                this.showThankyou = true;
                Helper.enableSpinner(false);
                sessionStorage.removeItem('arnNo');
                sessionStorage.removeItem('formDetails');

            }, (err) => {
                this.showThankyou = false;
                Helper.enableSpinner(false);
                this.redirectPageTo("/error");
            });
        // });
 
    
  }
  isDocUploadValid(type: string, status: boolean) {


    if (type === 'ProofOfAddress') {
      this.proofOfAddressValid = status;
      if (status) {
        document.getElementById('upload_3').style.visibility = 'hidden';
      }
      else {
        document.getElementById('upload_3').style.visibility = 'visible';
      }

    }
  }
}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/poa-form/poa-doc.component.ts